import { CanMatchFn, Route, UrlSegment } from '@angular/router';

/**
 * Sub-paths of `/training` that belong to the staff builder, not to a
 * participant landing token. The backend mints landing URLs as
 * `{frontend}/training/{token}`, so the public route has to be `training/:token`
 * — which would otherwise swallow `/training/builder`.
 */
const RESERVED_TRAINING_SEGMENTS = new Set(['builder']);

/**
 * Matches `training/:token` only when the segment is a real landing token,
 * letting the workspace's own `training/*` pages resolve normally.
 */
export const trainingTokenMatch: CanMatchFn = (
  _route: Route,
  segments: UrlSegment[],
) => {
  const token = segments[1]?.path ?? '';
  return !!token && !RESERVED_TRAINING_SEGMENTS.has(token.toLowerCase());
};
